import { render, staticRenderFns } from "./categoryManage.vue?vue&type=template&id=0643816c&scoped=true"
import script from "./categoryManage.vue?vue&type=script&lang=js"
export * from "./categoryManage.vue?vue&type=script&lang=js"
import style0 from "./categoryManage.vue?vue&type=style&index=0&id=0643816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643816c",
  null
  
)

export default component.exports